<template>
  <RouterLink
    :to="to"
    class="group inline-flex items-center gap-1 rounded-md px-1 py-0.5 text-background-fg/87 transition hover:bg-background-fg/8"
  >
    <div class="min-w-0"><slot /></div>
    <IconChevronRight
      class="size-3.5 shrink-0 text-background-fg/50 transition group-hover:translate-x-0.5 group-hover:text-background-fg/87"
    />
  </RouterLink>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router"

defineProps<{
  to: RouteLocationRaw
}>()
</script>
